import { CustomersPageSettingsService } from './customers-page-settings.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';

import { ConfirmBlockReasonComponent } from './confirm-block-reason/confirm-block-reason.component';
import { AlertService } from 'src/app/shared/components/app-alert';
import { ApiService } from 'src/app/shared/services/api.service';
import { Customer } from 'src/app/shared/models/customer.model';
import { ConfirmModalComponent } from 'src/app/shared/components/confirm-modal/confirm-modal.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-customers-page',
  templateUrl: './customers-page.component.html',
  styleUrls: [
    '../pages.sass',
    './customers-page.component.sass'
  ]
})
export class CustomersPageComponent implements OnInit {

  private rawData: Array<any> = [];
  public filteredData: Array<any> = [];
  public columns = this.settings.columns;
  public config = this.settings.config;

  public selectedGroups: Array<any> = [];

  public selectedCustomers = this.settings.selectedCustomers;

  public groupsFilterData = this.settings.groupsFilterData;

  public tableFilteredData: Array<any> = [];

  constructor(
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private alert: AlertService,
    private modal: BsModalService,
    private api: ApiService,
    private settings: CustomersPageSettingsService ) {
  }

  ngOnInit(): void {
    this.rawData = [];
    this.filteredData = [];
    this.selectedCustomers = [];
    this.selectedGroups = [];
    this.tableFilteredData = [];
    this.groupsFilterData = new Observable();
    
    this.api.get('customers', (result) => {
      this.processData(result);
    });
  }

  private processData(data: any) {
    this.rawData = data.map((customer: Customer) => ({
      Blocked: (customer.BlockReason ? this.settings.stringYes : this.settings.stringNo),
      OnlineSite: (customer.SiteOnline ? this.settings.stringYes : this.settings.stringNo),
      OnlineSiteInfo: (customer.SiteOnline ? `${customer.SiteOnline.Url}\n${customer.SiteOnline.Version}` : undefined),
      MLVersion: customer.MLSiteVersion ? customer.MLSiteVersion : '',
      Verified: customer.IsVerified === true ? this.settings.stringYes : this.settings.stringNo,
      ...customer
    }));

    this.updateBlockReasonFilterData();
    this.updateGroupsFilterData();
  }

  private updateBlockReasonFilterData() {
    let blockReasonFilterData = this.rawData.map(({ BlockReason }) => BlockReason);
    blockReasonFilterData = blockReasonFilterData.filter((reason, index) => reason && blockReasonFilterData.indexOf(reason) === index);

    let blockReasonFiltering = this.columns.find(column => column.name === 'Blocked').filtering;
    blockReasonFiltering.filterData =
      [
        this.settings.stringAllYes,
        this.settings.stringAllNo,
        ...blockReasonFilterData
      ];
  }

  private updateGroupsFilterData() {
    this.groupsFilterData = new Observable(subscriber => {
      const groupsFilterData: Array<any> = [];
      this.rawData.forEach(customer => {
        customer.Groups.forEach(customerGroup => {
          if (groupsFilterData.filter(group => group.Id === customerGroup.Id).length == 0) {
            groupsFilterData.push(customerGroup);
          }
        });
      });
      this.selectedGroups = this.settings.selectedGroups;
      this.onGroupsFilterChange();
      subscriber.next(groupsFilterData);
    });

    this.onGroupsFilterChange();
  }

  public onGroupsFilterChange(): any {
    if (this.selectedGroups.length == 0) {
      this.filteredData = this.rawData;
    } else {
      this.filteredData = this.rawData.filter(customer =>
        customer.Groups.filter(group =>
          this.selectedGroups.find(selGroup => selGroup.Id == group.Id)
        ).length > 0);
    }
  }

  public onCellClick(cell: any): any {
    const { Id } = cell.row;
    switch (cell.column.name) {
      case 'Name':
        this.settings.selectedGroups = this.selectedGroups;
        this.router.navigate([Id, 'requests'], { relativeTo: this.route });
        break;
      case 'LatestRequest.Date':
        const { LatestRequest } = cell.row;
        this.settings.selectedGroups = this.selectedGroups;
        this.router.navigate(['requests', LatestRequest.Id], { queryParams: { time: LatestRequest.Date } });
        break;
      case 'Blocked':
        if (cell.row.BlockReason) {
          this.unblock([{ Id: Id }]);
        } else {
          this.block([{ Id: Id }]);
        }
        break;
      default:
        break;
    }
  }

  public onTableChanged(data: any) {
    this.tableFilteredData = data;
    this.findSelectedCustomers();
    this.cdRef.detectChanges();
  }

  public onTableFiltersReseted(columns) {
    this.settings.columns = columns;
  }

  onBlock() {
    this.block(this.selectedCustomers);
  }

  onUnblock() {
    this.unblock(this.selectedCustomers);
  }

  // private performCommand(command: string, callback: () => any): void {
  //   if (this.selectedCustomers.length > 0) {
  //     this.modal.show((command === 'block') ? ConfirmBlockReasonComponent : ConfirmModalComponent, {
  //       initialState: {
  //         message: `Are you sure you want to ${command} selected customers?`,
  //         callback: (result) => {
  //           if (result == 'yes') {
  //             callback();
  //           }
  //         }
  //       }
  //     });
  //   } else {
  //     this.alert.warn(`Nothing selected to ${command}`);
  //   }
  // }

  public block(selectedCustomers: Array<any>) {
    if (selectedCustomers.length > 0) {
      this.modal.show(ConfirmBlockReasonComponent, {
        initialState: {
          message: `Are you sure you want to block selected customer${selectedCustomers.length > 1 ? '(s)' : ''}?`,
          callback: (result, blockReason) => {
            if (result == 'yes') {
              selectedCustomers = selectedCustomers.map((customer) => ({ BlockReason: blockReason, ...customer }));
              this.api.put('customers', selectedCustomers, (result: any) => {
                if (!result.error) {
                  selectedCustomers.forEach(selCustomer => {
                    let customer = this.rawData.find(customer => customer.Id === selCustomer.Id);
                    customer.BlockReason = blockReason;
                    customer.Blocked = this.settings.stringYes;
                  });
                  this.updateBlockReasonFilterData();
                }
              });
            }
          }
        }
      });
    } else {
      this.alert.warn(`Nothing selected to block`);
    }
  }

  public unblock(selectedCustomers: Array<any>) {
    if (selectedCustomers.length > 0) {
      this.modal.show(ConfirmModalComponent, {
        initialState: {
          message: `Are you sure you want to unblock selected customer${selectedCustomers.length > 1 ? '(s)' : ''}?`,
          callback: (result) => {
            if (result == 'yes') {
              selectedCustomers = selectedCustomers.map((customer) => ({ BlockReason: '', ...customer }));
              this.api.put('customers', selectedCustomers, (result: any) => {
                if (!result.error) {
                  selectedCustomers.forEach(selCustomer => {
                    let customer = this.rawData.find(customer => customer.Id === selCustomer.Id);
                    customer.BlockReason = undefined;
                    customer.Blocked = this.settings.stringNo;
                  });
                  this.updateBlockReasonFilterData();
                  this.onTableChanged(this.filteredData);
                }
              });
            }
          }
        }
      });
    } else {
      this.alert.warn(`Nothing selected to unblock`);
    }
  }

  private findSelectedCustomers() {
    this.selectedCustomers = this.tableFilteredData
      .filter(customer => customer.selected)
      .map(({ Id }) => ({ Id: Id }));
  }

  public groupsFilterGroupByFn = (group) => group.SimType.Name;

  public onExport = () => {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.tableFilteredData, 
      {
        header: ["Name", "LatestRequest.Date", "LatestRequest.State", "SerialNumber", "Blocked", "SiteOnline.Url", "SiteOnline.Version"],
        headerTitles: ["Customer Name", "Latest Request", "Status", "Serial Number", "Blocked", "Online Site", "Site Version"]
      }
    );

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Customers');

    /* save to file */
    XLSX.writeFile(wb, `AUCustomerList_${new Date(Date.now()).toLocaleString()}.xlsx`);
  }

  public onEnvironmentChanged(env) {
    console.log('Environment changed to:', env);
    this.ngOnInit();
  }
}
